<div>
  <div style="margin: 20px;">
    <div class="d-flex justify-content-around">
      <button mat-raised-button (click)="includeEmailAndLinksCheckDialog(false)">Download</button>
      <button mat-raised-button (click)="includeEmailAndLinksCheckDialog(true)" [disabled]="disableUploadBtn">
        <span class="d-flex align-items-center">
          <span>{{ 'logs.send_analysis' | translate }}</span>
          <mat-spinner class="ms-2" diameter="20" *ngIf="uploadingLog"></mat-spinner>
        </span>
      </button>
    </div>

    <div class="mt-3">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let flow of logsMap | keyvalue: asIsOrder">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ flow.key }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <ul style="padding-left: 0!important;">
              <li *ngFor="let log of flow.value" class="m-2">
                <strong>{{ 'logs.flow' | translate }}: </strong> {{ log.flow }},
                <strong>{{ 'logs.check' | translate }}: </strong> {{ log.check }},
                <strong>{{ 'logs.result' | translate }}: </strong> {{ log.result }},
                <strong>{{ 'logs.reason' | translate }}: </strong> {{ log.reason }},
                <strong>{{ 'logs.points_added' | translate }}: </strong> {{ log.points }}
                <strong *ngIf="log.linkDisplayedAs">, {{ 'logs.link_displayed_as' | translate }}: </strong>  {{ log.linkDisplayedAs }}
                <span *ngIf="log.link">
                  <strong>, {{ 'logs.link' | translate }}: </strong> {{ log.link.getAttribute('href') }}
                </span>
                <span *ngIf="log.attachment">,
                  <strong>{{ 'logs.attachment' | translate }}: </strong>  {{ log.attachment.name }}
                </span>
                <span *ngIf="log.qrCode">,
                  <strong>{{ 'logs.qr_code' | translate }}: </strong>  {{ log.qrCode.decoded }}
                </span>
              </li>
            </ul>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
